// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U4R4","content":"styles_content__M7xn6"};